'use strict';


export default class AdditionalContactModel {
  static getModel() {
    return model;
  }

}

const model = {
    firstName :{
        required :{
            message :'This field is required.'
        }
    },
    lastName :{
        required :{
            message :'This field is required.'
        }
    },
    title :{
        required :{
            message :'This field is required.'
        }
    },
    phoneNumber1 :{
      required: {
        message: 'This field is required.'
      },
      isLength: {
        options: {min: 10, max: 10},
        message: 'Must be 10 digits'
      },
      isNumeric: {
        message: 'Must be numeric'
      },
      matches: {
        options: /^[2-9]\d{9}$/,
        message: 'Must be a valid phone number.'
      }
    },
    email :{
        required :{
            message :'This field is required.'
        },
        isEmail: {
          message: 'Must be a valid email.'
        }
    },
    phoneExtension1: {},
    address: {},
    city: {
      required: {
        message: 'This field is required.'
      }
    },
    state: {
      required: {
        message: 'This field is required.'
      }
    },
    zip: {},
};



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/AdditionalContacts/AdditionalContactModel.js